import {combineReducers} from 'redux'
import types from 'actions/types'
import {get} from 'lodash'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_ADD_BULK_INVOICES_DIALOG:
      return true
    case types.HIDE_ADD_BULK_INVOICES_DIALOG:
      return false
    default:
      return state
  }
}

export const data = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_ADD_BULK_INVOICES_DIALOG:
      return action.data
    case types.HIDE_ADD_BULK_INVOICES_DIALOG:
      return null
    default:
      return state
  }
}

export const invoicedDateOption = (state = 'TODAY', action) => {
  switch (action.type) {
    case types.UPDATE_ADD_BULK_INVOICES_DIALOG:
      return get(action, 'data.invoicedDateOption', state)
    default:
      return state
  }
}

export default combineReducers({
  isVisible,
  data,
  invoicedDateOption,
})
